import { createRoot } from 'react-dom/client'
import React from 'react'
import NewsIndex from '../components/NewsIndex/App';

const PageNewsIndex = ($) => {
	if ($("body").hasClass("page-template-news-index")) {

		const newsIndexRootElement = document.getElementById("js--news-index");
		const newsIndexRoot = createRoot(newsIndexRootElement);
		newsIndexRoot.render(
			<NewsIndex/>
		);
	}
};

export default PageNewsIndex;
